import React, { useCallback, useMemo } from 'react';
import { Select, SelectOption } from '@hugendubel/react-basic';
import { SearchService } from '../../../services/search-service';
import { ProductFilter } from '../../../ws/WS';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';

const articleTypeOptions: ReadonlyArray<SelectOption<ProductFilter | undefined>> = [
    { value: undefined, label: { id: 'page.Home.articleType.all' } },
    { value: ProductFilter.ONLY_DOWNLOADS, label: { id: 'page.Home.articleType.onlyDownloads' } },
    { value: ProductFilter.NO_DOWNLOADS, label: { id: 'page.Home.articleType.noDownloads' } },
];

export const SearchProductFilter: React.FC = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const onChange = useCallback(
        (productFilter?: ProductFilter): void => {
            navigate(SearchService.calculateUrl({ pf: productFilter, page: 1 }));
        },
        [navigate]
    );
    const productFilter: ProductFilter | undefined = useMemo(
        () => SearchService.getProductFilterFromSearch(search),
        [search]
    );

    return <Select className="label-hidden" value={productFilter} onChange={onChange} options={articleTypeOptions} />;
};
